import { render, staticRenderFns } from "./PicIcon.vue?vue&type=template&id=101212fe&scoped=true&lang=pug&"
import script from "./PicIcon.vue?vue&type=script&lang=js&"
export * from "./PicIcon.vue?vue&type=script&lang=js&"
import style0 from "./PicIcon.vue?vue&type=style&index=0&id=101212fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101212fe",
  null
  
)

export default component.exports